import Container from "../../components/Container/Container";
import {useContext, useEffect, useState} from "react";
import {
    Button,
    Form,
    message,
    Popconfirm,
    Space,
    Statistic,
    Table,
    Tag,
    Tooltip,
} from "antd";
import Search from "../../components/Search/Search";
import getHiddenPayIns from "../../api/admin/pay-in/getHiddenPayIns";
import unhidePayIn from "../../api/admin/pay-in/unhidePayIn";
import useAuthHeader from "../../hooks/useAuthHeader";
import {formatDateTime, numberFormat} from "../../helpers/helpers";
import TextCopy from "../../components/TextCopy";
import {ReloadOutlined, EyeOutlined} from "@ant-design/icons";
import getBanks from "../../api/bank/getBanks";
import LoadingContext from "../../contexts/LoadingContext";
import dayjs from "dayjs";
import searchPartner from "../../api/partner/searchPartner";

function HiddenPayIn() {
    const accessToken = useAuthHeader();
    const [tableLoading, setTableLoading] = useState(false);
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [options, setOptions] = useState([]);
    const { setLoading } = useContext(LoadingContext);
    const [optionQuery, setOptionQuery] = useState([]);
    const [query, setQuery] = useState('');
    const [recordLoading, setRecordLoading] = useState({});
    const [summaryData, setSummaryData] = useState({
        totalAmount: 0,
        totalFee: 0,
        totalActualAmount: 0,
        totalTransactionAmount: 0
    });
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        search: {
            createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
        },
        filters: {},
        sorter: {
            field: 'pay_in_id',
            order: 'descend'
        }
    });

    const items = [
        {
            name: 'userId',
            type: 'search',
            placeholder: 'Đối tác',
            options: optionQuery.map((item) => {
                return {
                    value: item.userId,
                    text: item.name
                }
            }),
            onSearch: (value) => {
                setQuery(value)
            }
        },
        {
            name: 'uuid',
            placeholder: 'Mã đơn',
            type: 'text'
        },
        {
            name: 'requestId',
            placeholder: 'Mã tra soát',
            type: 'text'
        },
        {
            name: 'nickname',
            placeholder: 'Nickname',
            type: 'text'
        },
        {
            name: 'bankTransactionId',
            placeholder: 'Mã giao dịch ngân hàng',
            type: 'text'
        },
        {
            name: 'code',
            placeholder: 'Mã khớp',
            type: 'text'
        },
        {
            name: 'createdAt',
            placeholder: 'Thời gian',
            type: 'date'
        },
    ];

    const columns = [
        {
            title: 'ID',
            dataIndex: 'uuid',
            align: 'center',
            width: '200px',
            ellipsis: {
                showTitle: false,
            },
            render: (value) => {
                return (
                    <Tooltip placement="topLeft" title={value}>
                        <TextCopy value={value}/>
                    </Tooltip>
                )
            }
        },
        {
            title: 'Đối tác',
            dataIndex: 'username',
            align: 'center',
            width: '150px',
            ellipsis: {
                showTitle: false,
            },
            render: (value) => {
                return (
                    <Tooltip placement="topLeft" title={value}>
                        <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {value}
                        </span>
                    </Tooltip>
                )
            }
        },
        {
            title: 'Mã tra soát',
            dataIndex: 'requestId',
            width: '150px',
            align: 'center',
            ellipsis: {
                showTitle: false,
            },
            render: (value) => {
                return (
                    <Tooltip placement="topLeft" title={value}>
                        <TextCopy value={value}/>
                    </Tooltip>
                )
            }
        },
        {
            title: 'Nickname',
            dataIndex: 'nickname',
            width: '150px',
            align: 'center',
            ellipsis: {
                showTitle: false,
            },
            render: (value) => {
                if (value === 'null' || !value) {
                    return <Tag>Trống</Tag>
                }
                return (
                    <Tooltip placement="topLeft" title={value}>
                        <TextCopy value={value}/>
                    </Tooltip>
                )
            }
        },
        {
            title: 'Ngân hàng',
            dataIndex: 'bankName',
            align: 'center',
            width: '120px',
            filterMode: 'tree',
            filters: options,
            ellipsis: {
                showTitle: false,
            },
            render: (value) => {
                return (
                    <Tooltip placement="topLeft" title={value}>
                        <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {value}
                        </span>
                    </Tooltip>
                )
            }
        },
        {
            title: 'Tài khoản nhận',
            dataIndex: 'accNo',
            align: 'center',
            width: '150px',
            ellipsis: {
                showTitle: false,
            },
            render: (value) => {
                return (
                    <Tooltip placement="topLeft" title={value}>
                        <Tag style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>{value}</Tag>
                    </Tooltip>
                )
            }
        },
        {
            title: 'Mã khớp',
            dataIndex: 'code',
            width: '150px',
            align: 'center',
            ellipsis: {
                showTitle: false,
            },
            render: (value) => {
                return (
                    <Tooltip placement="topLeft" title={value}>
                        <TextCopy value={value}/>
                    </Tooltip>
                )
            }
        },
        {
            title: 'Số tiền tạo',
            dataIndex: 'amount',
            align: 'center',
            width: '130px',
            render: (value) => {
                return numberFormat(value)
            }
        },
        {
            title: 'Thực chuyển',
            dataIndex: 'transactionAmount',
            align: 'center',
            width: '130px',
            render: (value) => {
                return numberFormat(value)
            }
        },
        {
            title: 'Phí',
            dataIndex: 'fee',
            align: 'center',
            width: '100px',
            render: (value) => {
                return numberFormat(value)
            }
        },
        {
            title: 'Tiền cộng',
            dataIndex: 'actualAmount',
            align: 'center',
            width: '130px',
            render: (value) => {
                return numberFormat(value)
            }
        },
        {
            title: 'Mã giao dịch',
            dataIndex: 'bankTransactionId',
            width: '180px',
            align: 'center',
            ellipsis: {
                showTitle: false,
            },
            render: (value) => {
                if (value) {
                    return (
                        <Tooltip placement="topLeft" title={value}>
                            <TextCopy value={value}/>
                        </Tooltip>
                    )
                }
                return '-'
            }
        },
        {
            title: 'Trạng thái',
            dataIndex: 'state',
            align: 'center',
            width: '120px',
            filters: [
                {
                    text: 'Đang chờ',
                    value: 'pending'
                },
                {
                    text: 'Thành công',
                    value: 'processed'
                },
                {
                    text: 'Lỗi',
                    value: 'failed'
                },
                {
                    text: 'Cảnh báo',
                    value: 'warning'
                }
            ],
            render: (value) => {
                const statusMap = {
                    pending: { color: 'warning', label: 'Đang chờ' },
                    processed: { color: 'success', label: 'Thành công' },
                    failed: { color: 'error', label: 'Lỗi' },
                    warning: { color: 'warning', label: 'Cảnh báo'}
                };
                const { color, label } = statusMap[value] || { color: 'default', label: value };
                return <Tag color={color}>{label}</Tag>;
            }
        },
        {
            title: 'Trạng thái CB',
            dataIndex: 'isCallback',
            align: 'center',
            width: '120px',
            filters: [
                {
                    text: 'Đã callback',
                    value: true
                },
                {
                    text: 'Chưa callback',
                    value: false
                },
            ],
            render: (value) => {
                if (value) {
                    return <Tag color={'success'}>Đã CALLBACK</Tag>
                }
                return <Tag color={'yellow'}>Chưa CALLBACK</Tag>
            }
        },
        {
            title: 'Thời gian tạo',
            dataIndex: 'createdAt',
            align: 'center',
            width: '180px',
            render: (value) => {
                return (
                    <Tag>{formatDateTime(value)}</Tag>
                )
            }
        },
        {
            title: 'Thời gian hoàn thành',
            dataIndex: 'completedAt',
            align: 'center',
            width: '180px',
            render: (value) => {
                if (value) {
                    return (
                        <Tag>{formatDateTime(value)}</Tag>
                    )
                }
                return '-'
            }
        },
        {
            title: 'Địa chỉ IP',
            dataIndex: 'ipAddress',
            align: 'center',
            width: '130px',
            ellipsis: {
                showTitle: false,
            },
            render: (value) => {
                const displayValue = value || '-';
                return (
                    <Tooltip placement="topLeft" title={displayValue}>
                        <Tag style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>{displayValue}</Tag>
                    </Tooltip>
                )
            }
        },
        {
            title: 'Xử lý',
            dataIndex: 'handler',
            align: 'center',
            width: '120px',
            ellipsis: {
                showTitle: false,
            },
            render: (value) => {
                if (!value) {
                    return (
                        <Tag>Hệ thống</Tag>
                    )
                }
                return (
                    <Tooltip placement="topLeft" title={value}>
                        <Tag color={'blue'} style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>{value}</Tag>
                    </Tooltip>
                )
            }
        },
        {
            title: 'Hành động',
            dataIndex: 'operation',
            align: 'center',
            width: '120px',
            fixed: 'right',
            render: (_, record) => {
                return (
                    <Popconfirm
                        title="Bỏ ẩn đơn hàng"
                        description="Bạn có chắc chắn muốn bỏ ẩn đơn này?"
                        onConfirm={() => handleUnhidePayIn(record.uuid)}
                        okText="Đồng ý"
                        cancelText="Hủy"
                    >
                        <Button 
                            loading={!!recordLoading[record.uuid]} 
                            type="primary" 
                            icon={<EyeOutlined/>}
                            title="Bỏ ẩn đơn hàng"
                        >
                            Bỏ ẩn
                        </Button>
                    </Popconfirm>
                )
            }
        }
    ];

    const handleUnhidePayIn = async (uuid) => {
        setRecordLoading(prev => ({ ...prev, [uuid]: true }));
        const response = await unhidePayIn(accessToken, { uuid });
        if (response.success) {
            messageApi.success('Đã bỏ ẩn đơn hàng thành công');
            fetchDataTable(); // Refresh list
        } else {
            messageApi.error(response.message || 'Có lỗi xảy ra khi bỏ ẩn đơn hàng');
        }
        setRecordLoading(prev => ({ ...prev, [uuid]: false }));
    }

    const handleSearch = () => {
        const params = form.getFieldsValue();
        setTableParams({
            ...tableParams,
            pagination: {
                ...tableParams.pagination,
                current: 1 // Reset to first page when searching
            },
            search: {
                ...params
            }
        })
    }

    const handleTableChange = (pagination, filters, sorter) => {
        // Convert filters to the format expected by API
        const apiFilters = {};
        if (filters.bankName && filters.bankName.length > 0) {
            apiFilters.bankName = filters.bankName;
        }
        if (filters.state && filters.state.length > 0) {
            apiFilters.state = filters.state;
        }
        if (filters.isCallback && filters.isCallback.length > 0) {
            apiFilters.isCallback = filters.isCallback.map(val => val ? 1 : 0);
        }

        // Convert sorter to the format expected by API
        let apiSorter = {
            field: 'pay_in_id',
            order: 'descend'
        };
        if (sorter.field) {
            apiSorter = {
                field: sorter.field,
                order: sorter.order === 'ascend' ? 'ascend' : 'descend'
            };
        }

        setTableParams({
            ...tableParams,
            pagination,
            filters: apiFilters,
            sorter: apiSorter,
        });
    };

    const fetchDataTable = async () => {
        setTableLoading(true);
        
        // Prepare request params
        const params = {
            pagination: {
                pageSize: tableParams.pagination.pageSize,
                current: tableParams.pagination.current
            },
            search: {},
            filters: tableParams.filters || {},
            sorter: tableParams.sorter || {
                field: 'pay_in_id',
                order: 'descend'
            }
        };

        // Process search fields
        const searchValues = tableParams.search || {};
        if (searchValues.uuid) {
            params.search.uuid = searchValues.uuid;
        }
        if (searchValues.nickname) {
            params.search.nickname = searchValues.nickname;
        }
        if (searchValues.code) {
            params.search.code = searchValues.code;
        }
        if (searchValues.requestId) {
            params.search.requestId = searchValues.requestId;
        }
        if (searchValues.bankTransactionId) {
            params.search.bankTransactionId = searchValues.bankTransactionId;
        }
        if (searchValues.userId) {
            params.search.userId = parseInt(searchValues.userId);
        }
        if (searchValues.createdAt && searchValues.createdAt.length === 2) {
            params.search.createdAt = [
                searchValues.createdAt[0].format('YYYY-MM-DD'),
                searchValues.createdAt[1].format('YYYY-MM-DD')
            ];
        }

        const response = await getHiddenPayIns(accessToken, params);
        if (response.success) {
            setDataSource(response.data.data);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: response.data.total
                },
            });
            setSummaryData({
                totalAmount: response.data.totalAmount || 0,
                totalFee: response.data.totalFee || 0,
                totalActualAmount: response.data.totalActualAmount || 0,
                totalTransactionAmount: response.data.totalTransactionAmount || 0
            })
        } else {
            messageApi.error(response.message || 'Có lỗi xảy ra khi tải dữ liệu');
        }
        setTableLoading(false);
    }

    useEffect(() => {
        setLoading(true);
        const fetchBanks = async () => {
            const response = await getBanks(accessToken);
            if (response.success) {
                setOptions(response.data.map(item => ({
                    text: item.displayName,
                    value: item.bankName
                })))
            }
        }
        fetchBanks().finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        fetchDataTable();
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        JSON.stringify(tableParams.sorter),
        JSON.stringify(tableParams.search),
        JSON.stringify(tableParams.filters),
    ]);

    useEffect(() => {
        setLoading(true);
        const fetchPartners = async () => {
            const response = await searchPartner(accessToken, query);
            if (response.success) {
                setOptionQuery(response.data)
            }
        }
        fetchPartners().finally(() => setLoading(false));
    }, [query])

    return (
        <Container>
            {contextHolder}
            <Space style={{ marginBottom: 16 }}>
                <Button onClick={fetchDataTable} icon={<ReloadOutlined/>}>Làm mới</Button>
            </Space>
            <Search
                items={items}
                form={form}
                onSearch={handleSearch}
            />
            <Table
                rowKey="uuid"
                columns={columns}
                scroll={{
                    x: 2500,
                }}
                dataSource={dataSource}
                loading={tableLoading}
                bordered
                pagination={{
                    ...tableParams.pagination,
                    showSizeChanger: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} của ${total} đơn`,
                }}
                onChange={handleTableChange}
                summary={(data) => {
                    return (
                        <Table.Summary.Row style={{ backgroundColor: '#fafafa', fontWeight: 'bold' }}>
                            <Table.Summary.Cell index={0} colSpan={7}>
                                Tổng tiền
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} align="center" colSpan={1}>
                                <Tag color="blue" style={{ minWidth: 100, textAlign: 'center' }}>
                                    {numberFormat(summaryData.totalAmount)}
                                </Tag>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} align="center" colSpan={1}>
                                <Tag color="blue" style={{ minWidth: 100, textAlign: 'center' }}>
                                    {numberFormat(summaryData.totalTransactionAmount)}
                                </Tag>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} align="center" colSpan={1}>
                                <Tag color="blue" style={{ minWidth: 100, textAlign: 'center' }}>
                                    {numberFormat(summaryData.totalFee)}
                                </Tag>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} align="center" colSpan={1}>
                                <Tag color="blue" style={{ minWidth: 100, textAlign: 'center' }}>
                                    {numberFormat(summaryData.totalActualAmount)}
                                </Tag>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    );
                }}
            />
        </Container>
    )
}

export default HiddenPayIn;
